<template>
  <div>
    <HKLButton
      v-bind="btnAttrs"
      @click="open"
    />
    <HKLModal
      ref="modal"
      v-bind="modalAttrs"
      v-on="$listeners"
    >
      <slot />
    </HKLModal>
  </div>
</template>

<script>
import lodash from 'lodash'
import { computed } from 'vue-demi'
import { useRefModal } from '@/controls/Modal/modal.hook'
import HKLButton from '@/controls/Button/HKLButton.vue'
import HKLModal from '@/controls/Modal/HKLModal.vue'

export default {
  components: {
    HKLButton,
    HKLModal,
  },
  setup (_, { attrs }) {
    const { modal, open, close } = useRefModal()
    const btnAttrs = computed(() => lodash.pick(attrs, Object.keys(HKLButton.props)))
    const modalAttrs = computed(() => lodash.omit(attrs, Object.keys(HKLButton.props)))
    return {
      btnAttrs,
      modalAttrs,
      modal,
      open,
      close,
    }
  },
}
</script>

<style>

</style>
